<h2 mat-dialog-title class="rights-title">Benutzerrechte verwalten</h2>
<div class="rights-title-divider"></div>

<mat-dialog-content class="rights-content">
  <!-- User selector -->
  <mat-form-field appearance="outline" class="rights-user-select">
    <mat-label>Benutzer auswählen</mat-label>
    <mat-select
      [(value)]="selectedUser"
      (selectionChange)="onUserSelected()"
      placeholder="Bitte wählen"
      [disabled]="isLoadingUsers">
      <mat-option *ngFor="let user of allUsers" [value]="user">
        {{ getUserDisplayName(user) }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Loading users -->
  <div *ngIf="isLoadingUsers" class="rights-loading">
    <mat-icon class="rights-spinner">hourglass_empty</mat-icon>
    <span>Lade Benutzer...</span>
  </div>

  <!-- Loading rights -->
  <div *ngIf="isLoadingRights && !isLoadingUsers" class="rights-loading">
    <mat-icon class="rights-spinner">hourglass_empty</mat-icon>
    <span>Lade Rechte...</span>
  </div>

  <!-- No user selected yet -->
  <p *ngIf="!isLoadingUsers && !selectedUser" class="rights-empty">
    Bitte einen Benutzer auswählen.
  </p>

  <!-- Empty rights -->
  <p *ngIf="!isLoadingRights && selectedUser && rights.length === 0 && !isAdding" class="rights-empty">
    Keine Rechte vorhanden.
  </p>

  <!-- Rights list -->
  <div class="rights-list" *ngIf="!isLoadingRights && selectedUser && rights.length > 0">
    <mat-card
      class="right-card"
      *ngFor="let right of rights"
      [class.right-declined]="right.state === 'decline'">
      <div class="right-info">
        <mat-icon class="right-icon">security</mat-icon>
        <div class="right-details">
          <div class="right-name">{{ getRightLabel(right.id) }}</div>
          <div class="right-id">ID: {{ right.id }}</div>
        </div>
      </div>
      <div class="right-actions">
        <div class="right-actions-divider"></div>
        <mat-form-field appearance="outline" class="right-state-select">
          <mat-select
            [value]="right.state"
            [disabled]="isProcessing(right)"
            (selectionChange)="onChangeState(right, $event.value)">
            <mat-option *ngFor="let state of stateOptions" [value]="state.value">
              {{ state.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button
          mat-icon-button
          color="warn"
          [disabled]="isProcessing(right)"
          (click)="onDeleteRight(right)"
          aria-label="Recht entfernen"
          matTooltip="Entfernen">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>

  <!-- Add right form -->
  <div class="add-right-form" *ngIf="isAdding">
    <div class="add-right-form-divider"></div>
    <h3 class="add-right-title">Neues Recht hinzufügen</h3>
    <mat-form-field appearance="outline" class="add-right-field">
      <mat-label>Recht auswählen</mat-label>
      <mat-select [(value)]="newRightId" placeholder="Bitte wählen">
        <mat-option *ngFor="let option of availableRightOptions" [value]="option.id">
          {{ option.label }} ({{ option.id }})
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="add-right-field">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="newRightState">
        <mat-option *ngFor="let state of stateOptions" [value]="state.value">
          {{ state.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="add-right-buttons">
      <button
        mat-raised-button
        color="primary"
        [disabled]="newRightId == null"
        (click)="onAddRight()">
        <mat-icon>check</mat-icon>
        Speichern
      </button>
      <button mat-stroked-button (click)="onCancelAdd()">
        Abbrechen
      </button>
    </div>
  </div>
</mat-dialog-content>

<div class="rights-bottom-divider"></div>

<mat-dialog-actions class="rights-dialog-actions">
  <button
    mat-raised-button
    color="primary"
    class="rights-btn add-btn"
    *ngIf="selectedUser && !isAdding"
    (click)="onShowAddForm()">
    <mat-icon>add</mat-icon>
    <span>Hinzufügen</span>
  </button>
  <button
    mat-stroked-button
    class="rights-btn close-btn"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span>Schließen</span>
  </button>
</mat-dialog-actions>
